import { Lock, SearchX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, isRouteErrorResponse, useRouteError } from "react-router";

import { useDocumentTitle } from "@/components/page";
import { EmptyState, ErrorState } from "@/components/states";
import { paths } from "@/routes/paths";
import { Button } from "@punto-firma/ui/components/button";

const BackHome = () => {
  const { t } = useTranslation("errors");
  return (
    <Button asChild variant="outline" size="sm">
      <Link to={paths.home}>{t("backHome")}</Link>
    </Button>
  );
};

/** Dentro del shell: la sesión vale, pero el rol no llega a esta pantalla. */
export const ForbiddenPage = () => {
  const { t } = useTranslation("errors");
  useDocumentTitle(t("forbiddenTitle"));
  return (
    <div className="p-4 md:p-8">
      <EmptyState
        icon={Lock}
        title={t("forbiddenTitle")}
        description={t("forbiddenDescription")}
        action={<BackHome />}
      />
    </div>
  );
};

export const NotFoundPage = () => {
  const { t } = useTranslation("errors");
  useDocumentTitle(t("notFoundTitle"));
  return (
    <div className="p-4 md:p-8">
      <EmptyState
        icon={SearchX}
        title={t("notFoundTitle")}
        description={t("notFoundDescription")}
        action={<BackHome />}
      />
    </div>
  );
};

/**
 * Error al pintar o al cargar una zona (p. ej. un trozo del bundle que ya no
 * existe tras desplegar): se ofrece recargar.
 */
export const RouteErrorPage = () => {
  const { t } = useTranslation("errors");
  const error = useRouteError();
  useDocumentTitle(t("unexpectedTitle"));
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <ErrorState
        description={t("reloadDescription")}
        onRetry={() => window.location.reload()}
      />
    </div>
  );
};
